'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _simpleReactForm = require('simple-react-form');

var _Text = require('../Text');

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Filter = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Filter, _React$Component);

  function Filter() {
    (0, _classCallCheck3.default)(this, Filter);
    return (0, _possibleConstructorReturn3.default)(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).apply(this, arguments));
  }

  (0, _createClass3.default)(Filter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _simpleReactForm.Form,
          {
            state: this.props.variables,
            onChange: function onChange(_ref) {
              var filter = _ref.filter;
              return _this2.props.setVariable('filter', filter);
            } },
          _react2.default.createElement(_simpleReactForm.Field, {
            fieldName: 'filter',
            type: _Text2.default,
            placeholder: 'Search' })
        )
      );
    }
  }]);
  return Filter;
}(_react2.default.Component), _class.propTypes = {
  variables: _react2.default.PropTypes.object,
  setVariable: _react2.default.PropTypes.func
}, _temp);
exports.default = Filter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/meteor-paginated-graphql-react/lib/Head/Filter.js
// module id = 2680
// module chunks = 0